export class DumpsterListDeleteDumpstersInput {
  dumpsters: number[];

  constructor(dumpsters: number[]) {
    this.dumpsters = dumpsters;
  }
}
